var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 18.3346C5.39758 18.3346 1.66675 14.6038 1.66675 10.0013C1.66675 5.3988 5.39758 1.66797 10.0001 1.66797C14.6026 1.66797 18.3334 5.3988 18.3334 10.0013C18.3334 14.6038 14.6026 18.3346 10.0001 18.3346ZM10.0001 16.668C11.7682 16.668 13.4639 15.9656 14.7141 14.7153C15.9644 13.4651 16.6667 11.7694 16.6667 10.0013C16.6667 8.23319 15.9644 6.5375 14.7141 5.28726C13.4639 4.03701 11.7682 3.33464 10.0001 3.33464C8.23197 3.33464 6.53628 4.03701 5.28604 5.28726C4.03579 6.5375 3.33341 8.23319 3.33341 10.0013C3.33341 11.7694 4.03579 13.4651 5.28604 14.7153C6.53628 15.9656 8.23197 16.668 10.0001 16.668ZM9.16675 13.3346H10.8334V15.0013H9.16675V13.3346ZM9.16675 11.6746C9.16675 11.6746 10.8334 11.668 10.8334 11.6746C10.8334 10.8396 13.3334 10.0013 13.3334 8.33464C13.3334 6.49297 11.8559 5.0013 10.0076 5.0013C9.56921 5.00032 9.13495 5.08581 8.72967 5.25288C8.32438 5.41996 7.95603 5.66533 7.64571 5.97496C7.33539 6.28458 7.08918 6.65238 6.9212 7.05729C6.75321 7.4622 6.66675 7.89626 6.66675 8.33464H8.33341C8.33341 7.41797 9.08341 6.66797 10.0001 6.66797C10.9167 6.66797 11.6667 7.41797 11.6667 8.33464C11.6667 9.08464 9.16675 10.3071 9.16675 11.6746Z",
    fill: "#71839B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskQuestionIcon);
export default __webpack_public_path__ + "static/media/ask-question-icon.bdd67e560ccb80f976b7957dfd971e00.svg";
export { ForwardRef as ReactComponent };